// extracted by mini-css-extract-plugin
export var button = "_lq-0";
export var donut = "_lq-1";
export var donutFill = "_lq-3";
export var donutTrack = "_lq-2";